import React from 'react'
import useFetch from '../hooks/useFetch'

import SyntaxHighlighter from 'react-syntax-highlighter'
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs'

export default function CodeSnippet ({
    language,
    url,
    style = atomOneDark,
    lineNumberStyle = { color: 'rgba(112, 112, 112, 0.8)' },
    showLineNumbers = true
}) {
    const text = useFetch({ url, defaultValue: '', json: false })

    return (
        <SyntaxHighlighter lineNumberStyle={lineNumberStyle} showLineNumbers={showLineNumbers} language={language} style={style}>
            {text}
        </SyntaxHighlighter>
    )
}
